import clsx from 'clsx';
import { Base } from '../../../components/Base';
import Spinner from '../../../components/Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ListLoader-root_5uNnx Widget-widget__NYoi Widget-base_2xffH Widget-widgetFixedHeight_2GNLw Widget-widgetFixedWidth_aNuHK Widget-centered_2NDSy"
};
function ListLoader({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "span",
    className: clsx(styles.root, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx(Spinner, {
      name: "dots"
    })
  });
}
export default ListLoader;